require('normalize.css');
require('clarity-ui/dist/css/all/clarity.css');
require('styles/App.css');

import React from 'react';
import { connect } from 'react-redux';
import mainSelector from './main.selector';
import SiteNavigationLayout from './siteNavigation.layout';
import {
  SiteHeader,
  SiteHeaderUserMenu,
  SiteContent,
  SiteFooter,
  DropdownMenuItem,
  Loader,
  CustomSiteNotification
} from 'components/clarity-ui';

import _ from 'lodash';

/**
 * Top Level component.
 */
class MainComponent extends React.Component {

  getAccessErrorMessage () {
    return 'You do not have permissions to view that information';
  }

  getGeneralErrorMessage () {
    return (
      <label>
        If you would like to help us fix this problem, please send an email to <a href="mailto:contextual@epsilon.com">contextual@epsilon.com</a> that includes:
        <ul>
          <li>The time the error occurred.</li>
          <li>The browser version you are using.</li>
          <li>A brief description of the problem.</li>
        </ul>
        For immediate assistance, please message Sahil Bhatia or Walter Dworak on Teams.
      </label>
    );
  }

  componentWillMount () {
    const localtionPathName = !!this.props.currentPathLocation ? this.props.currentPathLocation.pathname.split('/')[1] : '';
    const menuItemRoute = localtionPathName !== '' ? localtionPathName : 'labelViewer';
    this.props.fetchAuth();
    this.setState({selectedMenuItem: menuItemRoute, notificationMsg: null, loading: true, errorRedirect: false});
  }

  componentDidUpdate (prevProps, prevState) {
    const newState = {};
    const { classifiersAccess, entityRecommenderAccess, accessError, generalError, currentPathLocation } = this.props;
    const { notificationMsg, loading, selectedMenuItem, isActive, errorRedirect } = this.state;
    const shouldTriggerAccessError = (_.contains(currentPathLocation.pathname, 'classifiers') && !classifiersAccess)
          || _.contains(currentPathLocation.pathname, 'entityRecommender') && !entityRecommenderAccess;
    const hasViewErrors = (!_.isEmpty(accessError) && (shouldTriggerAccessError || errorRedirect)) || !_.isEmpty(generalError),
          isViewNotificationNull = !notificationMsg && !prevState.notificationMsg,
          hasUserMenuChanged = !_.isEqual(isActive, prevState.isActive),
          hasNavigationItemChanged = !_.isEqual(selectedMenuItem, prevState.selectedMenuItem);

    if (hasViewErrors && isViewNotificationNull && !hasUserMenuChanged && !hasNavigationItemChanged) {
      _.assign(newState, {errorRedirect: false, notificationMsg: {
        getMessage: !_.isEmpty(generalError)
          ? this.getGeneralErrorMessage
          : this.getAccessErrorMessage,
        header: !_.isEmpty(generalError)
          ? 'Apologies!...something isn\'t right here.'
          : 'Access Error',
        type: 'error'
      }});
    }

    if (prevState.loading && loading && (!_.isEmpty(accessError) || !!classifiersAccess || !!entityRecommenderAccess )) {
      _.assign(newState, {loading: false});
      if (shouldTriggerAccessError) {
        _.assign(newState, {selectedMenuItem: 'labelViewer', errorRedirect: true});
        this.context.router.push(`/labelViewer`);
      }
    }

    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  }

  handleNavigationItemClick (e) {
    e.stopPropagation();
    this.setState({selectedMenuItem: e.currentTarget.id});
  }

  getSiteMenuOptions (hasClassifiersAccess, hasEntityRecommenderAccess) {
    const menuOptions = [
      {id: 'labelViewer', name: 'Label Viewer', iconClass: 'folder', linkTo: '/'}
    ];

    if (hasEntityRecommenderAccess)
      menuOptions.push({id: 'entityRecommender', name: 'Entity Search', iconClass: 'search', linkTo: '/entityRecommender'});

    return menuOptions;
  }

  handleHeaderUserMenuClick () {
    this.setState({
      isActive: !this.state.isActive
    });
  }

  handleLogOutButtonClick () {
    this.props.logOut();
  }

  handleSiteNotificationCloseButtonClick () {
    this.setState({
      notificationMsg: null
    });
  }

  renderAccessErrorNotification (notificationMsg) {
    return (
      <CustomSiteNotification
        type={notificationMsg.type}
        header={notificationMsg.header}
        onCloseButtonClick={this.handleSiteNotificationCloseButtonClick.bind(this)}>
        { notificationMsg.getMessage() }
      </CustomSiteNotification>
    );
  }

  renderMainLayout (props, state) {
    const { user, classifiersAccess, entityRecommenderAccess, children } = props;
    const { selectedMenuItem, isActive, notificationMsg, loading } = state

    return (
      <div className="index">
        <Loader loading={loading} />
        <SiteHeader title="Contextual">
          <SiteHeaderUserMenu
            onClick={this.handleHeaderUserMenuClick.bind(this)}
            userName={user.firstName + ' ' + user.lastName}
            isActive={isActive}
          >
            <DropdownMenuItem onClick={this.handleLogOutButtonClick.bind(this)}>Logout</DropdownMenuItem>
          </SiteHeaderUserMenu>
        </SiteHeader>
        <SiteContent>
          <SiteNavigationLayout
            menuOptions={this.getSiteMenuOptions(!!classifiersAccess, !!entityRecommenderAccess)}
            selectedMenuItem={selectedMenuItem}
            handleClick={this.handleNavigationItemClick.bind(this)} />
          <div className="SiteContent-main">
            { !!notificationMsg ? this.renderAccessErrorNotification(notificationMsg) : null }
            { children }
          </div>
        </SiteContent>
        <SiteFooter></SiteFooter>
      </div>
    );
  }

  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    return !!this.props.user ? this.renderMainLayout(this.props, this.state) : null;
  }
}

const mapStateToProps = () => {
  const getMainSelector = mainSelector;
  const stateToProps = (state) => {
    return getMainSelector(state);
  };
  return stateToProps;
}

MainComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(mapStateToProps)(MainComponent);



// WEBPACK FOOTER //
// ./src/components/layouts/main.layout.jsx